module.exports = __webpack_public_path__ + "static/img/logo1.367f3901.png";